import Emitter from './Emitter'
import io      from 'socket.io-client'

export default class {
  constructor (connections, store) {
    this.sockets = {}
    connections.forEach(connection => {
      if (typeof connection === 'string') {
        this.addSocket(io(connection))
      } else {
        this.addSocket(connection)
      }
    })

    if (store) this.store = store
    this.onEvent()
  }

  of (nsp) {
    nsp = nsp || '/'
    return this.sockets[nsp]
  }

  addSocket (socket) {
    this.sockets[socket.nsp] = socket
  }

  onEvent () {
    Object.keys(this.sockets).forEach(nsp => {
      let socket = this.sockets[nsp]
      let socketName = nsp.replace('/', '')
      var originalOnevent = socket.onevent
      socket.onevent = (packet) => {
        originalOnevent.call(socket, packet)

        packet.data[0] = socketName === '' ? packet.data[0] : `${socketName}_${packet.data[0]}`
        Emitter.emit.apply(Emitter, packet.data)
        if (this.store) this.passToStore(`SOCKET_${packet.data[0]}`, ...packet.data.slice(1))
      }

      let _this = this;

      [
        'connect',
        'error',
        'disconnect',
        'reconnect',
        'reconnect_attempt',
        'reconnecting',
        'reconnect_error',
        'reconnect_failed',
        'connect_error',
        'connect_timeout',
        'connecting',
        'ping',
        'pong'
      ]
        .forEach((value) => {
          _this.sockets[nsp].on(value, (data) => {
            let label = socketName === '' ? value : `${socketName}_${value}`
            Emitter.emit(label, data)
            if (value === 'connect') data = _this.of(nsp)
            if (_this.store) _this.passToStore(`SOCKET_${label}`, data)
          })
        })
    })
  }

  // call store functions
  passToStore (event, payload) {
    if (!event.startsWith('SOCKET_')) return
    for (let namespaced in this.store._mutations) {
      let mutation = namespaced.split('/').pop()
      if (mutation === event) this.store.commit(namespaced, payload)
    }
    for (let namespaced in this.store._actions) {
      let action = namespaced.split('/').pop()

      if (!action.startsWith('socket_')) continue

      let camelcased = event.replace('SOCKET_', 'socket_')

      if (action === camelcased) this.store.dispatch(namespaced, payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/vue-multichannel-scoketio/Observer.js